import { useLayoutContext } from "layout/layout-provider";
import { useEffect, useState } from "react";

const useLayoutUtils = () => {
  // State per memorizzare l'altezza del corpo della pagina
  const [bodyHeight, setBodyHeight] = useState(-1);

  // Ottieni lo stato footerLoaded dal contesto del layout
  const { footerLoaded } = useLayoutContext();

  useEffect(() => {
    // Verifica se il footer è caricato
    if (!footerLoaded) return;

    // Attendere che il footer si carichi completamente prima di calcolare l'altezza del corpo
    setTimeout(() => {
      // Seleziona gli elementi header e footer usando le classi CSS
      const header = document.querySelector(".lottie-animation.header") as HTMLElement;
      const footer = document.querySelector(".lottie-animation.footer") as HTMLElement;

      // Ottieni i rettangoli che rappresentano le posizioni e dimensioni degli elementi header e footer
      const rect1 = header.getBoundingClientRect();
      const rect2 = footer.getBoundingClientRect();

      // Calcola l'altezza massima possibile tra l'elemento header e il top dell'elemento footer
      const maxHeight = rect2.top - rect1.bottom;

      // Imposta l'altezza del corpo con il valore calcolato
      setBodyHeight(maxHeight);
    }, 200); // Attendi 200 millisecondi prima di eseguire il calcolo (può essere regolato in base alle esigenze)
  }, [footerLoaded]); // Esegui l'effetto solo quando il valore di footerLoaded cambia

  // Restituisci l'altezza del corpo come risultato
  return { bodyHeight };
};

export default useLayoutUtils;